export default "__VITE_ASSET__fWmXg91A__"